import * as React from 'react';
import { FelaComponent, Container, FlexGrid } from '@filou/core';
import { Link, withRouteData } from 'react-static';
import { renderText, cloudinary } from 'filou-web';

const rule = ({ theme }) => ({
  position: 'fixed',
  left: 30,
  top: 60,
  backgroundColor: theme.color,
  width: 50,
  height: 50,
  borderRadius: 100,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  textAlign: 'center',
  fontSize: 50,
  textDecoration: 'none',
  color: theme.light
});
const ButtonLink = () => (
  <FelaComponent
    rule={rule}
    render={({ className }) => (
      <Link to="/#spezialisten" className={className}>
        <span>&#8249;</span>
      </Link>
    )}
  />
);
class Experte extends React.Component {
  componentDidMount() {
    document.body.style.overflow = 'hidden';
  }
  componentWillUnmount() {
    document.body.style.overflow = 'initial';
  }
  render() {
    const { item } = this.props;
    return (
      <FelaComponent
        style={{
          backgroundColor: 'white',
          position: 'fixed',
          zIndex: 2,
          top: 0,
          left: 0,
          width: '100vw',
          height: '100vh',
          overflow: 'auto'
        }}
      >
        <Container>
          <FelaComponent
            style={{
              padding: 25,
              '& img': {
                float: 'left',
                borderRadius: 100,
                marginTop: 10,
                marginRight: 10
              },
              '& h5': {
                marginBottom: 0
              }
            }}
          >
            <ButtonLink />
            <FlexGrid size={3} gutter={10}>
              <FlexGrid.Item size={2}>
                {item.bild && (
                  <img
                    src={cloudinary(item.bild.url, 'w_400,h_400,c_fill')}
                    width={100}
                    height="auto"
                  />
                )}
                <h1>{item.name}</h1>
                <h5>Primärer Schwerpunkt</h5>
                {item.schwerpunkt}
                <h5>Praxis</h5>
                {item.praxisname}
                <h5>Adresse</h5>
                {item.adresse}
              </FlexGrid.Item>
              <FlexGrid.Item size={1}>
                <h3>Kontakt</h3>
                {item.website && <h5 style={{ marginBottom: 0 }}>Website</h5>}
                {item.website && item.website.url}
                <h5>E-Mail</h5>
                {item.email}
                <h5>Telefon</h5>
                {item.telefon}
              </FlexGrid.Item>
            </FlexGrid>
            <FlexGrid size={3} gutter={10}>
              <FlexGrid.Item size={2}>
                <h3>Motivation</h3>
                {renderText(item.motivation)}
              </FlexGrid.Item>
              {/*<FlexGrid.Item size={1}>
                <h3>Zusatzbezeichnungen</h3>
                <h3>Schwerpunkte</h3>
              </FlexGrid.Item>*/}
            </FlexGrid>
            {/*<FlexGrid size={3} gutter={10}>
              <FlexGrid.Item size={2}>
                <h3>Erfahrung</h3>
              </FlexGrid.Item>
              <FlexGrid.Item size={1}>
                <h3>Berufsverbände</h3>
                <h5>Facharzt</h5>
              </FlexGrid.Item>
            </FlexGrid>*/}
          </FelaComponent>
        </Container>
      </FelaComponent>
    );
  }
}

export default withRouteData(Experte);
